import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export var switchTab = normalize.switchTab(function () {
  throw new Error('@uni/apis: switchTab 不支持');
}, CONTAINER_NAME.WEB);
export default switchTab;